import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
  selector: 'app-target-set',
  templateUrl: './target-set.component.html',
  styleUrls: ['./target-set.component.scss']
})
export class TargetSetComponent implements OnInit {
  target:any = {}
formGroup: FormGroup;
  submitted: boolean = false;
  constructor(
    public modalService: NgbModal,
    public fb: FormBuilder,
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
  ) { }

  ngOnInit() {
    this.initForm();
    this.getTargetAcceptance()
  }

  initForm() {
    this.formGroup = this.fb.group({
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
      target_acceptance_id: ['', Validators.required]
    });
  }
  getTargetAcceptance(){
    this.apiService.get(this.apiConfig.getTargetSetDetails).subscribe((res:any)=>{
      console.log(res)
      this.target = res.data;
    })
  }

  editTarget(targetModal, targetData) {
    this.formGroup.patchValue({
      start_date: targetData.start_date,
      end_date: targetData.end_date,
      target_acceptance_id: targetData.id

    });
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  onSubmitTarget(formData) {
    console.log(formData);
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    console.log('Form submitted:', formData);
    this.apiService.post(this.apiConfig.setTargetset,formData).subscribe((res:any)=>{
      console.log(res);
      this.getTargetAcceptance();
      this.modalService.dismissAll()
    })
  }

}
